export default __webpack_public_path__ + "static/media/account_circle_active.7bcc46f7.svg";